import { ReactElement } from "react"
import './style.scss'


interface Props {
    children: ReactElement
    content?: ReactElement
    rightBar?: boolean
    disabled?: boolean
}

export function RightBar(props: Props) {
    const { children, disabled } = props

    return (
        <div className={disabled ? 'disabled p-6 rounded-b-[20px] bg-brandPrimary-100' : 'p-6 rounded-b-[20px] bg-brandPrimary-100 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]'} style={{ height: '100%' }}>
            {children}
        </div>

    )
}